import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { btnCls, cget, cpost, cput, errText, inputCls } from "./api";

const PRODUCTS = ["core", "golf", "gym", "voice_premium", "atelier"];
const blankP = () => ({ name: "", email: "", amounts: { core: 0.3, golf: 0.3, gym: 0.3, voice_premium: 0.3, atelier: 1 }, active: true, start_date: "", end_date: "" });

const PrincipalRow = ({ p, set, del, i }) => (
  <div className="mt-2 rounded-xl border border-[#eee9dc] bg-white p-3" data-testid={`principal-row-${i}`}>
    <div className="flex flex-wrap gap-2">
      <input className={inputCls} placeholder="Name" value={p.name} onChange={(e) => set({ ...p, name: e.target.value })} data-testid={`principal-name-${i}`} />
      <input className={inputCls} placeholder="Email" value={p.email || ""} onChange={(e) => set({ ...p, email: e.target.value })} />
      <input className={inputCls} type="date" value={p.start_date || ""} onChange={(e) => set({ ...p, start_date: e.target.value })} title="Start" />
      <input className={inputCls} type="date" value={p.end_date || ""} onChange={(e) => set({ ...p, end_date: e.target.value })} title="End" />
      <label className="flex items-center gap-1 text-xs"><input type="checkbox" checked={p.active} onChange={(e) => set({ ...p, active: e.target.checked })} /> Active</label>
      <button type="button" onClick={del} className="text-xs text-[#a0522d] underline">Remove</button>
    </div>
    <div className="mt-2 flex flex-wrap gap-2 text-xs">
      {PRODUCTS.map((k) => (
        <label key={k} className="flex items-center gap-1">{k} £
          <input type="number" step="0.01" min="0" className={`${inputCls} w-20`} value={p.amounts?.[k] ?? 0} data-testid={`principal-${i}-${k}`}
            onChange={(e) => set({ ...p, amounts: { ...p.amounts, [k]: e.target.value } })} />
        </label>
      ))}
    </div>
  </div>
);

const NetworkEditor = ({ net, onSaved }) => {
  const [n, setN] = useState(net || { name: "", status: "active", principals: [blankP(), blankP()] });
  const save = () => (net ? cput(`/networks/${net.id}`, n) : cpost("/networks", n))
    .then(() => { toast.success("Network saved"); onSaved(); if (!net) setN({ name: "", status: "active", principals: [blankP(), blankP()] }); })
    .catch((e) => toast.error(errText(e)));
  const setP = (i, p) => setN({ ...n, principals: n.principals.map((x, j) => (j === i ? p : x)) });
  return (
    <div className="rounded-2xl border border-[#e5e0d3] bg-[#fbfaf6] p-4" data-testid={`network-editor-${net?.id || "new"}`}>
      <div className="flex flex-wrap items-center gap-2">
        <input className={inputCls} placeholder="Network name" value={n.name} onChange={(e) => setN({ ...n, name: e.target.value })} data-testid="network-name-input" />
        <select className={inputCls} value={n.status} onChange={(e) => setN({ ...n, status: e.target.value })}><option>active</option><option>paused</option><option>closed</option></select>
        {net && <span className="text-xs text-[#8a8a8a]">ID {net.id} · created {net.created_at?.slice(0, 10)}</span>}
      </div>
      {n.principals.map((p, i) => <PrincipalRow key={p.id || i} i={i} p={p} set={(v) => setP(i, v)} del={() => setN({ ...n, principals: n.principals.filter((_, j) => j !== i) })} />)}
      <div className="mt-3 flex gap-2">
        <button type="button" className="text-xs underline" onClick={() => setN({ ...n, principals: [...n.principals, blankP()] })}>+ Add Principal</button>
        <button type="button" className={btnCls} onClick={save} data-testid="network-save-btn">{net ? "Save" : "Create network"}</button>
      </div>
    </div>
  );
};

export const NetworksTab = () => {
  const [list, setList] = useState([]);
  const load = () => cget("/networks").then((d) => setList(d.networks)).catch(() => {});
  useEffect(() => { load(); }, []);
  return (
    <div className="space-y-4" data-testid="commissions-networks-tab">
      <p className="text-xs text-[#6b6b6b]">Network Principals are paid a fixed £ amount per qualifying payment, separate from the Affiliate/Partner percentages. Yearly memberships count as 12 monthly payments.</p>
      {list.map((n) => <NetworkEditor key={n.id} net={n} onSaved={load} />)}
      <NetworkEditor onSaved={load} />
    </div>
  );
};
